<template lang="html">
  <v-container>
    <StandardDialog v-if="show_dialog" @click-outside="show_dialog=false">
      <template #content>
        <StandardTextCard
          height="74vh"
          :name="'Upgrade for User: ' + dialog.user.first_name + ' ' + dialog.user.last_name + ' (' + getRequestedRole(dialog.information.type) + ')'"
          :clickable="false"
        >
          <template #info>
            <h3>Information</h3>
            <v-form v-if="dialog.information.type==='FullUser'">
              <v-text-field disabled v-model="dialog.information.experience.years" label="EXPERIENCE.years" type="number"></v-text-field>
              <v-text-field disabled v-model="dialog.information.experience.projects" label="EXPERIENCE.projects" type="number"></v-text-field>
              <v-text-field disabled v-model="dialog.information.project.name" label="PROJECT.name" type="text"></v-text-field>
              <v-text-field disabled v-model="dialog.information.project.description" label="PROJECT.description" type="text"></v-text-field>
            </v-form>
            <v-form v-if="dialog.information.type==='Single' || dialog.information.type==='integration' || dialog.information.type==='bi'">
              <div class="select-container">
                <v-text-field disabled v-model="dialog.information.billing_address_country" label="BILLING.address country" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_zip_code" label="BILLING.address zip code" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_state" label="BILLING.address state" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_city" label="BILLING.address city" type="text"></v-text-field>
              </div>
              <div class="select-container">
                <v-text-field disabled v-model="dialog.information.billing_address_street" label="BILLING.address street" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_building_number" label="BILLING.address building number" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_custom_information" label="BILLING.address custom information" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.vat_number" label="VAT.number" type="text"></v-text-field>
              </div>
              <div class="clear"></div>
            </v-form>
            <v-form v-if="dialog.information.type==='Business'">
              <div class="select-container">
                <v-text-field disabled v-model="dialog.information.billing_address_country" label="BILLING.address country" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_zip_code" label="BILLING.address zip code" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_state" label="BILLING.address state" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_city" label="BILLING.address city" type="text"></v-text-field>
              </div>
              <div class="select-container">
                <v-text-field disabled v-model="dialog.information.billing_address_street" label="BILLING.address street" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_building_number" label="BILLING.address building number" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.billing_address_custom_information" label="BILLING.address custom information" type="text"></v-text-field>
                <v-text-field disabled v-model="dialog.information.vat_number" label="VAT.number" type="text"></v-text-field>
              </div>
              <div class="clear"></div>
              <v-text-field disabled v-model="dialog.information.business_name" label="COMPANY.name" type="text"></v-text-field>
              <v-text-field disabled v-model="dialog.information.business_description" label="COMPANY.description" type="text"></v-text-field>
              <v-text-field disabled v-model="dialog.information.business_emails" label="COMPANY.email domains (comma separated)" placeholder="@takting.com, @example.com" type="text"></v-text-field>
            </v-form>
          </template>
          <template #actions>
            <v-btn color="blue" text @click="deleteUserUpgradeDialog({id: dialog.id, payload: { 'accept': true}})">Accept</v-btn>
            <v-btn color="red" text @click="deleteUserUpgradeDialog({id: dialog.id, payload: { 'accept': false}})">Decline</v-btn>
            <v-btn color="grey" text @click="show_dialog=false">Cancel</v-btn>
          </template>
        </StandardTextCard>
      </template>
    </StandardDialog>
    <StandardDialog v-if="show_dialog_upgrade_new_user" @click-outside="show_dialog_upgrade_new_user=false">
      <template #content>
        <StandardTextCard
          height="74vh"
          :name="'Upgrade User'"
          :clickable="false"
        >
          <template #info>
            <h3>Information</h3>
            <v-form>
              <v-text-field v-model="dialog_upgrade_new_user.email" label="USER.email" type="text"></v-text-field>
              <div class="select-container">
                <v-text-field v-model="dialog_upgrade_new_user.billing_address_country" label="BILLING.address country" type="text"></v-text-field>
                <v-text-field v-model="dialog_upgrade_new_user.billing_address_zip_code" label="BILLING.address zip code" type="text"></v-text-field>
                <v-text-field v-model="dialog_upgrade_new_user.billing_address_state" label="BILLING.address state" type="text"></v-text-field>
                <v-text-field v-model="dialog_upgrade_new_user.billing_address_city" label="BILLING.address city" type="text"></v-text-field>
              </div>
              <div class="select-container">
                <v-text-field v-model="dialog_upgrade_new_user.billing_address_street" label="BILLING.address street" type="text"></v-text-field>
                <v-text-field v-model="dialog_upgrade_new_user.billing_address_building_number" label="BILLING.address building number" type="text"></v-text-field>
                <v-text-field v-model="dialog_upgrade_new_user.billing_address_custom_information" label="BILLING.address custom information" type="text"></v-text-field>
                <v-text-field v-model="dialog_upgrade_new_user.vat_number" label="VAT.number" type="text"></v-text-field>
              </div>
              <div class="clear"></div>
              <v-text-field v-model="dialog_upgrade_new_user.business_name" label="COMPANY.name" type="text"></v-text-field>
              <v-text-field v-model="dialog_upgrade_new_user.business_description" label="COMPANY.description" type="text"></v-text-field>
              <v-text-field v-model="dialog_upgrade_new_user.business_emails" label="COMPANY.email domains (comma separated)" placeholder="@takting.com, @example.com" type="text"></v-text-field>
            </v-form>
            <v-alert v-if="show_dialog_feedback" type="error">{{show_dialog_feedback}}</v-alert>
          </template>
          <template #actions>
            <v-btn color="blue" text @click="upgradeUserToProUserBusinessLocal(dialog_upgrade_new_user)">Upgrade</v-btn>
            <v-btn color="grey" text @click="show_dialog_upgrade_new_user=false">Cancel</v-btn>
          </template>
        </StandardTextCard>
      </template>
    </StandardDialog>
    <v-row>
      <v-col xs12 md8 v-if="getAllUserUpgrades.length === 0">
        <v-card>
          <h1>No user upgrades here...</h1>
          <v-btn @click="show_dialog_upgrade_new_user = true">Upgrade a User</v-btn>
        </v-card>
      </v-col>
      <v-col xs12 md8 v-if="getAllUserUpgrades.length > 0">
        <v-data-table
          :headers="headers"
          :items="getAllUserUpgrades"
          :sort-by="[]"
          :sort-desc="[false, true]"
          multi-sort
          single-select
          class="elevation-1"
        >
          <template v-slot:item.copy="{ item }">
            <v-tooltip
              :open-on-hover="false"
              bottom
            >
              <template #activator="{ on }">
                <v-icon
                  medium
                  class="mr-2"
                  :disabled="!hasPermission('User READ ALL')"
                  @click="on.click"
                  @blur="on.blur"
                  @click.native="copyEmail(item.user.email)"
                >
                  content_copy
                </v-icon>
              </template>
              <span>Email copied to clipboard</span>
            </v-tooltip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              medium
              class="mr-2"
              :disabled="!hasPermission('UserUpgrade DELETE')"
              @click="showDialog(item)"
            >
              info
            </v-icon>
            <!-- <v-icon
              medium
              class="mr-2"
              :disabled="!hasPermission('UserUpgrade DELETE')"
              @click="deleteUserUpgrade({id: item.id, payload: { 'accept': true}})"
            >
              check_circle_outline
            </v-icon>
            <v-icon
              medium
              :disabled="!hasPermission('UserUpgrade DELETE')"
              @click="deleteUserUpgrade({id: item.id, payload: { 'accept': false}})"
            >
              highlight_off
            </v-icon> -->
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue';
import { mapActions, mapGetters } from 'vuex';
import store from '@/store/index';
export default {
  name: 'UserUpgrades',
  components: { StandardDialog, StandardTextCard },
  beforeRouteEnter (to, from, next) {
    store.dispatch('User/requestUserUpgradesForManagement').then(res => next(res));
  },
  data: function () {
    return {
      show_dialog: false,
      show_dialog_upgrade_new_user: false,
      show_dialog_feedback: '',
      dialog_upgrade_new_user: {
        billing_address_country: '',
        billing_address_zip_code: '',
        billing_address_state: '',
        billing_address_city: '',
        billing_address_street: '',
        billing_address_building_number: '',
        billing_address_custom_information: '',
        vat_number: '',
        business_name: '',
        business_description: '',
        business_emails: '',
      },
      dialog: {},
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Email', value: 'user.email' },
        { text: 'Copy Email to Clipboard', value: 'copy' },
        { text: 'First Name', value: 'user.first_name' },
        { text: 'Last Name', value: 'user.last_name' },
        { text: 'Current Role', value: 'current_role.name' },
        { text: 'Requested Role', value: 'requested_role.name' },
        { text: 'Date', value: 'created' },
        { text: 'Actions', value: 'actions', sortable: false },
      ]
    }
  },
  computed: {
    ...mapGetters('User', [
      'getAllUserUpgrades'
    ]),
    ...mapGetters('Auth', [
      'hasPermission'
    ])
  },
  methods: {
    ...mapActions('User', [
      'requestUserUpgradesForManagement',
      'upgradeUserToProUserBusiness',
      'deleteUserUpgrade'
    ]),
    upgradeUserToProUserBusinessLocal(payload){
      let self = this;
      this.upgradeUserToProUserBusiness(payload)
      .then(() => {
        self.show_dialog_upgrade_new_user = false;
        self.show_dialog_feedback = '';
        self.dialog_upgrade_new_user = {
          billing_address_country: '',
          billing_address_zip_code: '',
          billing_address_state: '',
          billing_address_city: '',
          billing_address_street: '',
          billing_address_building_number: '',
          billing_address_custom_information: '',
          vat_number: '',
          business_name: '',
          business_description: '',
          business_emails: '',
        };
      })
      .catch(err => {
        if (err.response && err.response.status) {
          this.show_dialog_feedback = err.response.data.error_msg;
        }
      });
    },
    copyEmail(email){
      navigator.clipboard.writeText(email);
    },
    showDialog(item){
      this.dialog = item;
      this.show_dialog = true;
    },
    deleteUserUpgradeDialog(payload){
      this.deleteUserUpgrade(payload);
      let self = this;
      setTimeout(function () {
        self.show_dialog = false;
      }, 1500);
    },
    getRequestedRole(type){
      switch (type) {
        case 'FullUser':
          return 'FULL.user'
        case 'Business':
          return 'PRO.user COMPANY'
        case 'Single':
          return 'PRO.user SINGLE'
        case 'bi':
          return 'PRO.user BI'
        case 'integration':
          return 'PRO.user INTEGRATION'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="css" scoped>
.select-container {
  width: 45%;
  padding: 10px;
  margin: 10px;
  position: relative;
  float: left;
}
</style>
